import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, TrendingDown, Clock, DollarSign, Users } from 'lucide-react';
export function ProblemSlide() {
  const stats = [{
    icon: Users,
    label: 'Rep Access',
    value: 'Down 50%+',
    desc: 'Digital is now mandatory',
    color: 'text-red-600',
    bg: 'bg-red-50'
  }, {
    icon: Clock,
    label: 'Campaigns',
    value: '70%',
    desc: 'Underperform targets',
    color: 'text-orange-600',
    bg: 'bg-orange-50'
  }, {
    icon: DollarSign,
    label: 'Wasted Spend',
    value: '$50B+',
    desc: 'Annually in pharma',
    color: 'text-amber-600',
    bg: 'bg-amber-50'
  }];
  return <div className="h-full flex flex-col" data-id="element-277">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-full" data-id="element-278">
        {/* Left: Context */}
        <div className="flex flex-col justify-center space-y-8" data-id="element-279">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="p-6 rounded-2xl bg-gray-50 border border-gray-200" data-id="element-280">
            <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-281">
              <AlertTriangle className="w-5 h-5 text-red-500" data-id="element-282" />
              The Trap
            </h3>
            <div className="space-y-4" data-id="element-283">
              <div className="flex justify-between items-center p-3 rounded bg-gray-100" data-id="element-284">
                <span className="text-gray-600" data-id="element-285">Traditional Agencies</span>
                <span className="text-red-500 font-medium" data-id="element-286">
                  Expensive & Slow
                </span>
              </div>
              <div className="flex justify-between items-center p-3 rounded bg-gray-100" data-id="element-287">
                <span className="text-gray-600" data-id="element-288">Internal SaaS</span>
                <span className="text-red-500 font-medium" data-id="element-289">
                  Volume without Depth
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-290">
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-291">
              HCPs demand more.
            </h3>
            <p className="text-xl text-gray-500 leading-relaxed" data-id="element-292">
              They want personalized, rewarding{' '}
              <span className="text-purple-600 font-medium" data-id="element-293">micro-science</span>
              , not generic blasts.
            </p>
          </motion.div>
        </div>

        {/* Right: Stats Grid */}
        <div className="flex flex-col justify-center gap-6" data-id="element-294">
          {stats.map((stat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + idx * 0.1
        }} className="flex items-center gap-6 p-6 rounded-2xl bg-gray-50 border border-gray-200 hover:bg-gray-100 transition-colors" data-id="element-295">
              <div className={`w-14 h-14 rounded-xl ${stat.bg} flex items-center justify-center shrink-0`} data-id="element-296">
                <stat.icon className={`w-7 h-7 ${stat.color}`} data-id="element-297" />
              </div>
              <div data-id="element-298">
                <div className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-299">
                  {stat.label}
                </div>
                <div className={`text-3xl font-bold ${stat.color} mb-1`} data-id="element-300">
                  {stat.value}
                </div>
                <div className="text-gray-500 text-sm" data-id="element-301">{stat.desc}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}